import api from './api';
import types from './mutation-types';

export default {
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getBomInfo_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getBomInfo({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'gridList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
